module.exports = __webpack_public_path__ + "static/media/salestribe-brand.db42bc2a.svg";